import { useAppType } from '../app/useAppType';
import { useAndReportExperimentTreatment } from '../experiments';

type UseShouldUseTeamsFocusNavigation = () => boolean;
export const useShouldUseTeamsFocusNavigation: UseShouldUseTeamsFocusNavigation = () => {
  const appType = useAppType();
  const isTeamsPersonal = appType === 'YammerTeamsPersonalApp';
  const teamsFocusCommandsInEngageApp = useAndReportExperimentTreatment('TeamsFocusCommandsInEngageApp') === true;

  return isTeamsPersonal && teamsFocusCommandsInEngageApp;
};
